var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 42.7,
    height: 42.7,
    rx: 12.35,
    fill: "url(#paint0_linear_4646_64276)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 42.7,
    height: 42.7,
    rx: 12.35,
    stroke: "url(#paint1_linear_4646_64276)",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.4923V27.3608C16 27.7956 16.158 28.2125 16.4393 28.5199C16.7206 28.8273 17.1022 29 17.5 29H26.5C26.8978 29 27.2794 28.8273 27.5607 28.5199C27.842 28.2125 28 27.7956 28 27.3608V24.4923M22.0007 15L22.0007 24.2886M22.0007 24.2886L18.5721 20.7395M22.0007 24.2886L25.4293 20.7395",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4646_64276",
    x1: 21.16,
    y1: -12.125,
    x2: 21.16,
    y2: 41.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D84C23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4646_64276",
    x1: 22,
    y1: 1,
    x2: 22,
    y2: 40.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D84B22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDownload);
export default __webpack_public_path__ + "static/media/ReportDownload.db5a2ecc2208f314576082f862e44cad.svg";
export { ForwardRef as ReactComponent };